import { useQuery } from "react-query";
import SchemaService from "../api/services/SchemaService";

export const useProductSchema = (queryKey: string, id: string | null) => {
  const { data, isLoading, isError, refetch, error } = useQuery(
    [queryKey, id],
    async () => await SchemaService.getProductSchema(id),
    {
      enabled: !!id
    }
  );

  return {
    productSchema: data?.data?.schema,
    isProductSchemaLoading: isLoading,
    productSchemaError: error,
    isProductSchemaError: isError,
    fetchProductSchema: refetch
  }
}